import { runInsertNode } from '@adornis/prosemirror-editor/prosemirror-helpers/runInsertNode.js';
import { isNodeSelection } from '@adornis/prosemirror-editor/prosemirror-helpers/util.js';
import { type INodeConfig, MenuItemGroup } from '@adornis/prosemirror-editor/types.js';
import { BHBuildifyFlexConfiguration } from './configuration.js';
import { flexEditor } from './editor.js';
import './node-flex.js';

const defaultConfig = JSON.stringify({ _class: BHBuildifyFlexConfiguration._class });

export const flexNodeConfig: INodeConfig = {
  node: {
    name: 'flex',
    schema: {
      draggable: true,
      isolating: true,
      content: 'block+',
      group: 'block',
      attrs: { config: { default: defaultConfig } },
      parseDOM: [{ tag: 'node-flex', getAttrs: dom => ({ config: dom.getAttribute('config') ?? defaultConfig }) }],
      toDOM: node => ['node-flex', { config: node.attrs.config }, 0],
    },
  },
  config: BHBuildifyFlexConfiguration,
  editor: flexEditor,
  menuItems: [
    {
      group: MenuItemGroup.LAYOUT,
      label: 'Flex',
      icon: 'icon-[mdi--view-column]',
      run: view =>
        runInsertNode('flex', state => ({
          attrs: { config: defaultConfig },
          content: [state.schema.nodes.paragraph!.create()],
        }))(view.state, view),
      shouldVisualize: view => !isNodeSelection(view.state.selection),
    },
  ],
};
